// extracted by mini-css-extract-plugin
export default {"wrapperInner":"ManagementAndCosts_wrapperInner__2V4ON","root":"ManagementAndCosts_root__LLNao","collapseContainer":"ManagementAndCosts_collapseContainer__2zYoo"};